<template>
  <!--添加  -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="AddList"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="标题" prop="title">
              <el-input
                placeholder="请输入内容"
                v-model="AddList.title"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="摘要" prop="zhaiyao">
              <el-input
                placeholder="请输入内容"
                v-model="AddList.zhaiyao"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
              label="长图"
              prop="ossUrl"
              ref="ossUrl"
              class="shadow"
            >
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <img
                  v-if="AddList.ossUrl"
                  :src="AddList.ossUrl"
                  class="avatar"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="封面图"
              prop="coverUrl"
              ref="coverUrl"
              class="shadow"
            >
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccessCoverUrl"
              >
                <img
                  v-if="AddList.coverUrl"
                  :src="AddList.coverUrl"
                  class="avatar"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证

      if (this.AddList.ossUrl == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      loadUpt: false,
      videoUploadTag: false,
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      imgLoad: false, //加载load
      newsStatus: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      //添加的参数：
      AddList: {
        title: "", //标题
        ossUrl: "", //长图
        zhaiyao: "", //摘要
        coverUrl:"",  //封面图
      },
      toAdRule: {
        zhaiyao: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        ossUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
        coverUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
      },
    };
  },
  methods: {
    // 封面图上传成功
    upSuccessCoverUrl(file) {
      this.AddList.coverUrl = file.entity;
      if (file.entity) {
        this.$refs.coverUrl.clearValidate();
      }
    },
    upSuccess(file) {
      console.log(file, "-------------");
      this.AddList.ossUrl = file.entity;
      if (file.entity) {
        this.$refs.ossUrl.clearValidate();
      }
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/zidingyiPage/insert", {
            title: this.AddList.title, //标题
            ossUrl: this.AddList.ossUrl, //长图
            coverUrl:this.AddList.coverUrl,//封面图
            zhaiyao: this.AddList.zhaiyao, //主办单位
            mediaType: 1, //媒体类型，
          }).then((res) => {
            if (res.success == true) {
              this.$router.push("/longPic");
              this.$message.success("添加成功！");
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {},
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    .shadow {
      /deep/ .el-upload {
        width: 200px;
        height: auto;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        outline: 0;
        border: 2px dashed #eee;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
    }

    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }

    /deep/ .el-upload-list--picture-card {
      margin: 0;
      display: inline;
      vertical-align: top;
      // display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
  }
}
/deep/.el-dialog {
  margin-top: 0 !important;
}
</style>